import http from "./http";

const SEARCH_INDEX_STORAGE_KEY = "hramota.searchIndex";

let cachedSearchIndex = null;
let searchIndexRequest = null;

function readStoredSearchIndex() {
    try {
        const storedValue = sessionStorage.getItem(SEARCH_INDEX_STORAGE_KEY);
        return storedValue ? JSON.parse(storedValue) : null;
    } catch {
        return null;
    }
}

function storeSearchIndex(items) {
    try {
        sessionStorage.setItem(SEARCH_INDEX_STORAGE_KEY, JSON.stringify(items));
    } catch {
        // Search still works with the in-memory cache when storage is unavailable.
    }
}

export async function getSearchIndex() {
    if (cachedSearchIndex) {
        return cachedSearchIndex;
    }

    const storedSearchIndex = readStoredSearchIndex();
    if (Array.isArray(storedSearchIndex)) {
        cachedSearchIndex = storedSearchIndex;
        return cachedSearchIndex;
    }

    if (!searchIndexRequest) {
        searchIndexRequest = http.get("/api/search/index")
            .then((res) => {
                const items = Array.isArray(res.data) ? res.data : [];
                cachedSearchIndex = items;
                storeSearchIndex(items);
                return items;
            })
            .finally(() => {
                searchIndexRequest = null;
            });
    }

    return searchIndexRequest;
}
